import { useSuspenseQuery } from "@tanstack/react-query";
import { orderHistoryApi } from "@/features/my-order/features/order-history/api";
import useIdentity from "@/features/ui/hooks/use-identity";
import { companyTypeRequestFormatConverter } from "@/utils/converter";

const useGetOrderSheetSetInquiries = (orderSheetSetId?: number | null) => {
  const identity = useIdentity();
  const companyId = identity?.company?.id;
  const companyType =
    companyTypeRequestFormatConverter[identity?.company?.type ?? "BUYER"];

  const canFetch = Boolean(orderSheetSetId && companyId);

  return useSuspenseQuery({
    queryKey: [
      "order-sheet-set",
      "inquiries",
      companyType,
      companyId,
      orderSheetSetId,
    ],
    queryFn: () => {
      if (!canFetch) return { inquiries: [] };
      return orderHistoryApi.getOrderSheetSetInquiries({
        companyType,
        companyId,
        orderSheetSetId: orderSheetSetId!,
      });
    },
    refetchOnWindowFocus: "always",
  });
};

export default useGetOrderSheetSetInquiries;
